const defaultLabelClass = "text-sm text-charcoal";
const defautlValueClass = "text-dark-elephant text-sm truncate";

export const DetailListItem = (props: {
  label: string;
  children: React.ReactNode;
  labelClass?: string;
  valueClass?: string;
  hidden?: boolean;
}) => {
  return (
    <>
      <dt className={props.labelClass ? props.labelClass : defaultLabelClass}>
        {props.label}
      </dt>
      <dd className={props.valueClass ? props.valueClass : defautlValueClass}>
        {props.children}
      </dd>
    </>
  );
};
